module.exports = __webpack_public_path__ + "img/box-packaging@2x.c9d344e4.png";